import type { TelegramUser } from "@/types/User";
import { usePolling } from "@roman/shared/hooks/usePolling";
import type { RomanApiError } from "@roman/shared/lib/net/romanApi";
import romanApi from "@roman/shared/lib/net/romanApi";
import type { SWRMutationConfiguration } from "swr/mutation";
import useSWRMutation from "swr/mutation";

type FetchUserResponse = {
  user: TelegramUser;
};

const POLLING_INTERVAL = 10000;

const fetcher = (url: string, args: { arg: { telegramUserId: number } }) =>
  romanApi.get<FetchUserResponse, { telegramUserId: number }>(url, args.arg);

export const useFetchUser = (
  options?: SWRMutationConfiguration<FetchUserResponse, RomanApiError, string, { telegramUserId: number }>,
) => {
  const { startPolling: _startPolling, stopPolling: _stopPolling } = usePolling({
    interval: POLLING_INTERVAL,
  });

  const mutation = useSWRMutation<FetchUserResponse, RomanApiError, string, { telegramUserId: number }>(
    "/user",
    (url: string, args: { arg: { telegramUserId: number } }) => fetcher(url, args),
    options,
  );

  const startPolling = (telegramUserId: number) => {
    _startPolling(async () => {
      await mutation.trigger({ telegramUserId });
    });
  };

  return {
    mutation,
    startPolling,
    stopPolling: _stopPolling,
  };
};
